import { Stack } from 'braid-design-system';
import React from 'react';

import {
  FEATURE_PER_UNIT_BILLING,
  useFeatureToggleData,
} from 'src/app/shared/featureToggle';
import PageLayout from 'src/app/v1/views/layouts/PageLayout';
import { FaqSection } from 'src/app/v1/views/sections/FaqSection';

import { ExtraTaskSteps } from '../ExtraTaskSteps';
import { SuccessHeader } from '../SuccessHeader';
import { UpsellPanel } from '../UpsellPanel';
interface Props {
  jobId?: string;
}
export const SuccessBodyContent = ({ jobId }: Props) => {
  const isPerUnitBilling = useFeatureToggleData(FEATURE_PER_UNIT_BILLING);
  return (
    <PageLayout headerContent={<SuccessHeader />}>
      <Stack space="xlarge">
        <ExtraTaskSteps jobId={jobId} />
        {!isPerUnitBilling && <UpsellPanel />}
        <FaqSection />
      </Stack>
    </PageLayout>
  );
};
